import { render } from "./GrandPermissionsToAdmins.vue?vue&type=template&id=4d5731d0&ts=true"
import script from "./GrandPermissionsToAdmins.vue?vue&type=script&lang=ts"
export * from "./GrandPermissionsToAdmins.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__